{
  "audit.history.change-type.added": "Pridané",
  "audit.history.change-type.collection": "Zmena kolekcie",
  "audit.history.change-type.deleted": "Vymazaný záznam",
  "audit.history.change-type.initial": "Vytvorené",
  "audit.history.change-type.other": "Zmena",
  "audit.history.change-type.reference": "Zmena prepojenia",
  "audit.history.change-type.removed": "Odstránené",
  "audit.history.change-type.value": "Zmena hodnoty",
  "audit.history.commit.author-label": "Autor",
  "audit.history.commit.current-version": "Najnovšie zmeny",
  "audit.history.commit.date-label": "Dátum zmeny",
  "audit.history.commit.id-label": "Identifikátor zmeny",
  "audit.history.commit.performed-changes-count": "{count, plural, one {# zmena} few {# zmeny} other {# zmien}}",
  "audit.history.commit.performed-changes-title": "Vykonané zmeny",
  "audit.history.empty.text": "Pre tento záznam zatiaľ nie sú dostupné auditné záznamy.",
  "audit.history.empty.title": "História je prázdna",
  "audit.history.error": "Auditnú históriu sa nepodarilo načítať.",
  "audit.history.loading": "Načítava sa auditná história...",
  "audit.history.property-select.all": "Všetky zmeny",
  "audit.history.property-select.changes-count": "{count, plural, one {# zmena} few {# zmeny} other {# zmien}}",
  "audit.history.property-select.changes-title": "História zmien atribútu",
  "audit.history.property.unknown": "Zmena",
  "audit.history.title": "História zmien",
  "audit.history.version-select.option": "Zmeny dňa {date}",

  "console.actions.export-txt.button.trigger.tooltip": "Export do .txt",
  "console.editor.button.run.text": "Spustiť",
  "console.field.use-transaction": "Vykonať v transakcii",
  "console.log.clear": "Vymazať",
  "console.log.title": "Log",
  "console.output.clear": "Vymazať",
  "console.output.title": "Výstup",
  "console.type.groovy": "Groovy",
  "console.type.javascript": "JavaScript",

  "permissions.check-all": "Všetko",
  "permissions.uncheck-all": "Nič",

  "role.evidence.table.title": "Roly",
  "role.fields.title.label": "Názov",
  "role.tabs.base-info": "Základné informácie",
  "role.tabs.permission": "Oprávnenia"
}
